<template>
  <div class="downPage">
    <div class="downloadpage">
      <div class="bgc">
        <img src="../assets/img/img1.jpg" />
      </div>
      <div class="logo">
        <img src="../assets/img/logo.png" />
      </div>
      <div class="down_btns">
        <div class="btns" @click="anDownload">Android下载</div>
        <div class="btns" @click="iosDownload">IOS下载</div>
      </div>
    </div>
    <div class="mcover" v-if="show">
      <p class="text">请在浏览器中打开并下载</p>
      <div class="close" @click="closePage">我知道了</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "down",
  data() {
    return {
      show: false
    };
  },
  methods: {
    closePage() {
      this.show = false;
    },
    anDownload () {
      if (this.isWechat()) {
        this.show = true;
      } else {
        if (this.isIos()) return this.Toast('暂不支持下载');
        this.getDownUrl(1);
      }
    },
    iosDownload () {
      if (this.isWechat()) {
        this.show = true;
      } else {
        if (!this.isIos()) return this.Toast('暂不支持下载');
        this.getDownUrl(2);
      }
    },
    getDownUrl (num) {
      this.axios.get('/xxgf-api/api/app/version/getLastAppVersion?appType=' + num)
        .then(({data}) => {
          if (data.code === 200) {
            window.location.href = data.data.url;
          }
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.downPage {
  width: 100%;
  background:#fff;
  .downloadpage{
    width:100%;
    .bgc{
      width:100%;
      height:580px;
      img{
        width:100%;
        height:100%;
      }
    }
    .logo{
      width:200px;
      height:100px;
      margin: 50px auto 0;
      img{
        width:100%;
        height:100%;
      }
    }
    .down_btns{
      display:flex;
      margin-top:200px;
      justify-content:center;
      .btns{
        width:250px;
        height:80px;
        border-radius: 40px;
        background:#d72f1d;
        color:#fff;
        line-height:80px;
        text-align:center;
        font-size:30px;
        margin:0 20px;
      }
    }
  }
  .mcover{
    position:fixed;
    top:0;
    left:0;
    z-index:50;
    width:100%;
    height:100%;
    background:rgba($color: #000000, $alpha: 0.8) url('../assets/img/icon_fenxiang_jiantou.png') no-repeat 560px 20px / 128px 100px;
    padding-top:200px;
    color:#fff;
    .text{
      font-size:40px;
      line-height:60px;
      padding: 0 100px;
    }
    .close{
      width:200px;
      height:80px;
      line-height:80px;
      text-align:center;
      margin:200px auto 0;
      background:gray;
      border-radius: 20px;
    }
  }
}
</style>
